let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aVyUQ")).then(() => parcelRequire('dk3Kn'));